export default "__VITE_ASSET__TPAdEEeH__";